module.exports = __webpack_public_path__ + "img/logo.d765703f.svg";